import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import SvgInfo from '../../../../../play-core/icons/Info';
import { MediaTypeIcon } from '../../../../../play-core/icons/MediaTypeIcon';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { ellipsis } from '../../../../../play-core/styles/style-helper';
import { utcToCentralEuropean } from '../../../../../play-core/utils/date-helper';
import { formatTime, shortTimeFormat } from '../../../utils/date-formatter';
import { IconWrapper } from '../../IconWrapper/IconWrapper';
import { isLive } from '../tv-guide-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ListProgramEntry = ({
  program,
  channel,
  onSelectProgram,
  activeChannelId
}) => {
  const {
    t
  } = useTranslation();
  const title = program.subtitle ? `${program.title}: ${program.subtitle}` : program.title;
  const isOnAir = isLive(program) && channel.type === 'srg';
  const isActiveChannel = channel.id === activeChannelId;
  return /*#__PURE__*/_jsxs(Layout, {
    tabIndex: program.tabIndex ?? -1,
    isActive: isOnAir && isActiveChannel,
    onClick: () => onSelectProgram({
      program,
      channel
    }),
    role: "button",
    "aria-label": `
        ${channel.title} - 
        ${program.title} - 
        ${program.subtitle ? `${program.subtitle} - ` : ''}
        ${formatTime(program.startTime, t)} 
        ${t('date.range.to')} 
        ${formatTime(program.endTime, t)} - 
        ${t('global.moreInformation')}`,
    onKeyDown: event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onSelectProgram({
          program,
          channel
        });
      }
    },
    children: [/*#__PURE__*/_jsx(Time, {
      children: program.isFollowUp ? t('tvGuide.afterwardsShorthand') : shortTimeFormat(utcToCentralEuropean(new Date(program.startTime)))
    }), !isActiveChannel && (program.mediaUrn || isOnAir) && /*#__PURE__*/_jsx(IconWrapper, {
      size: 28,
      icon: /*#__PURE__*/_jsx(MediaType, {
        mediaType: "VIDEO",
        isHovering: true
      })
    }), /*#__PURE__*/_jsx(Title, {
      children: title
    }), program.broadcastInfo && /*#__PURE__*/_jsx(InfoIcon, {
      size: 24,
      color: Colors.GREY_969696,
      icon: /*#__PURE__*/_jsx(SvgInfo, {})
    })]
  });
};
const Layout = styled.div.withConfig({
  displayName: "ListProgramEntry__Layout",
  componentId: "sc-1n4syg1-0"
})(["height:65px;width:100%;display:flex;align-items:center;background-color:", ";", ";color:", ";padding-left:8px;"], props => props.isActive ? Colors.GREY_454545 : Colors.GREY_2a2a2a, Fonts.regular(14), Colors.WHITE);
const Time = styled.span.withConfig({
  displayName: "ListProgramEntry__Time",
  componentId: "sc-1n4syg1-1"
})(["white-space:nowrap;min-width:60px;"]);
const Title = styled.span.withConfig({
  displayName: "ListProgramEntry__Title",
  componentId: "sc-1n4syg1-2"
})(["", ";"], ellipsis);
const MediaType = styled(MediaTypeIcon).withConfig({
  displayName: "ListProgramEntry__MediaType",
  componentId: "sc-1n4syg1-3"
})(["margin-right:8px;"]);
const InfoIcon = styled(IconWrapper).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "ListProgramEntry__InfoIcon",
  componentId: "sc-1n4syg1-4"
})(["flex-grow:1;justify-content:flex-end;margin-right:14px;"]);